var collapsible_list_pair_rtlignore_default = {
  "container": "-e11W",
  "title": "qYtMr",
  "viewerContainer": "HIUur",
  "titleContainer": "mDhEA",
  "expandIcon": "D8ukN",
  "dndIcon": "_0PK-6",
  "RTL": "SqcNt",
  "LTR": "AP6v5",
  "itemContainer": "_8gENq",
  "itemContainerViewer": "uFmWp",
  "mouseDown": "uIrnR",
  "innerEditor": "Viygi",
  "item": "XqQ31",
  "floatingAddPluginMenuWrapper": "jU1Vr",
  "childrenHidden": "iF1FH"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
